<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <BreadCrumbs
          v-model="deviceGroupId"
          :modelId="modelId"
          :serialNo="serialNo"
          @click_breadCrumbs="selectedGroupChange"
          @click_breadCrumbsDevice="selectedDeviceChange"
        />
        <v-divider />
      </v-col>
    </v-row>
    <v-row justify="center" align-content="center">
      <v-col cols="12">
        <v-card outlined>
          <!-- タイトル -->
          <v-card-title>
            <v-row dense>
              <v-col cols="8">
                <custom-icon type="machineInfo" :size="30" :colors="['#162A4F']" class="mr-3"> </custom-icon>
                <span :style="{ display: 'inline-block', height: 100 + '%', 'vertical-align': 'top' }">
                  {{ machine }}
                </span>
              </v-col>
              <v-spacer />
              <v-col cols="12" xl="1" lg="1" md="2" sm="12">
                <v-btn @click="downloadCSV" color="primary" block depressed>
                  CSV
                  <v-icon>mdi-download</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="12">
                <v-divider></v-divider>
              </v-col>
            </v-row>
          </v-card-title>
          <!-- パラメータ設定 -->
          <v-card-text class="mt-2">
            <v-row>
              <v-col class="ml-5 body-1" cols="4" xl="1" lg="2" md="3" sm="4">
                {{ $t('customerSMachineNo') }}
              </v-col>
              <v-col class="body-1" cols="6" xl="2" lg="2" md="4" sm="5">
                {{ customer }}
              </v-col>
            </v-row>
            <v-row>
              <v-row class="d-flex align-start mx-3">
                <v-col class="ml-5 pt-6 body-1" cols="3" xl="1" lg="2" md="3" sm="4">
                  {{ $t('displayRange') }}
                </v-col>
                <v-col cols="4" xl="1" lg="2" md="2" sm="3">
                  <v-select v-model="selectedItem" :items="items" hide-details outlined dense></v-select>
                </v-col>
                <!-- 開始日カレンダー -->
                <v-col cols="5" xl="2" lg="2" md="3" sm="4" class="ml-1">
                  <v-row no-gutters>
                    <v-col cols="12">
                      <Calendar
                        ref="startCal"
                        v-model="startSelectedDate"
                        type="date"
                        :allowInput="true"
                        :label="selectedItem === 'anyPeriod' ? 'From' : ''"
                      />
                    </v-col>
                    <v-col cols="12" v-if="selectedItem === 'anyPeriod'" class="mt-4">
                      <Calendar ref="endCal" v-model="endSelectedDate" type="date" :allowInput="true" label="To" />
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" xl="1" lg="1" md="2" sm="12">
                  <v-btn @click="updateChart" color="primary" block depressed>
                    <custom-icon type="trendGraph" :size="22" :colors="['#FFFFFF', '#FFFFFF', '#FFFFFF']">
                    </custom-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-row>
          </v-card-text>
          <!-- トレンドグラフ -->
          <v-card-text>
            <Chart ref="pressureChart" type="line" height="250px" :rangeCtrl="true" />
            <Chart ref="temperatureChart" type="line" height="250px" :rangeCtrl="true" />
            <Chart ref="electricCurrentChart" type="line" height="250px" :rangeCtrl="true" />
            <Chart ref="loadChart" type="line" height="250px" :rangeCtrl="true" />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <!-- ダイアログ -->
    <v-dialog v-model="dialog">
      <v-card>
        <v-card-title>{{ $t('longTimePeriodIsSpecified') }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="dialogCancel" dark small depressed><v-icon>mdi-close</v-icon></v-btn>
          <v-btn color="primary" @click="dialogOK" dark small depressed
            ><v-icon>mdi-checkbox-marked-circle-outline</v-icon></v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import CustomIcon from '../components/CustomIcon.vue';
  import Calendar from '../components/Calendar.vue';
  import Chart from '../components/Chart.vue';
  import BreadCrumbs from '../components/BreadCrumbs.vue';
  import infoPresetTrendgroups from '../resources/info_preset_trendgroups.json';
  import csv from '@/utils/csv';

  export default {
    title() {
      return this.$t(this.$route.meta.title);
    },
    name: 'TrendGraph',
    components: {
      CustomIcon,
      Calendar,
      Chart,
      BreadCrumbs,
    },
    mixins: [csv],
    data: () => ({
      localeId: 2,
      machine: '',
      customer: '',
      selectedItem: 1,
      modelId: '',
      serialNo: '',
      deviceGroupId: '',
      sensors: [],
      trendGroupSensors: [],
      infoPresetTrendgroup: null,
      pressureOptions: {},
      temperatureOptions: {},
      electricCurrentOptions: {},
      loadOptions: {},
      startSelectedDate: null,
      endSelectedDate: null,
      dialog: false,
      resolveDialog: null,
    }),
    computed: {
      items() {
        return [
          { text: this.$t('1Day'), value: 1 },
          { text: this.$t('1Week'), value: 7 },
          { text: this.$t('1Month'), value: 31 },
          { text: this.$t('halfYear'), value: 180 },
          { text: this.$t('1Year'), value: 365 },
          {
            text: this.$t('anyPeriodSetting'),
            value: 'anyPeriod',
          },
        ];
      },
    },
    async created() {
      // デフォルト年月日
      this.startSelectedDate = this.$dayjs().format('YYYY-MM-DD');
      this.endSelectedDate = this.$dayjs().format('YYYY-MM-DD');

      // URLから値を取得
      this.modelId = this.$route.params.model_id;
      this.serialNo = this.$route.params.serial_no;

      this.$store.commit('loading/start_loading');

      // ぱんくずリスト設定
      const userDeviceAuthorities = await this.apiRequest('/v1/master-info/userDeviceAuthorities', 'GET', {
        model_id: this.modelId,
        serial_no: this.serialNo,
      });
      if (userDeviceAuthorities === null) {
        this.$store.commit('loading/end_loading');
        return;
      }
      this.deviceGroupId = userDeviceAuthorities[0].device_group_id;

      // デバイス情報取得
      const devices = await this.apiRequest('/v1/master-info/devices', 'GET', {
        model_id: this.modelId,
        serial_no: this.serialNo,
      });
      if (devices === null) {
        this.$store.commit('loading/end_loading');
        return;
      }

      // プリセットグループを選択
      const infoPresetTrendgroup = infoPresetTrendgroups.filter(
        (infoPresetTrendgroup) => infoPresetTrendgroup.model_id === devices[0].model_id
      );
      if (infoPresetTrendgroup.length === 0) {
        this.$store.commit('snackbar/show_snackbar', {
          text: 'トレンドグラフ対象外の装置マスタです。',
          color: 'error',
          timeout: 5000,
          multiline: false,
        });
        this.$store.commit('loading/end_loading');
        return;
      }
      this.infoPresetTrendgroup = infoPresetTrendgroup[0];

      // ロケールを変更
      await this.setLocale();

      this.machine = devices[0][`name_locale${this.localeId}`];
      this.customer = devices[0].optional_info_2;

      // センサー情報取得
      const sensors = await this.apiRequest('/v1/master-info/sensors', 'GET', {
        model_id: this.modelId,
        serial_no: this.serialNo,
      });
      if (sensors === null) {
        this.$store.commit('loading/end_loading');
        return;
      }
      this.sensors = sensors.filter(
        (sensor) =>
          !sensor.name_locale2.startsWith('DI-') &&
          !sensor.name_locale2.startsWith('DO') &&
          !sensor.name_locale2.startsWith('予備')
      );
      this.sensors.sort((a, b) => {
        if (a.sensor_id.startsWith('sa') && b.sensor_id.startsWith('sn')) return 1;
        if (a.sensor_id.startsWith('sn') && b.sensor_id.startsWith('sa')) return -1;
        if (a.sensor_id < b.sensor_id) return -1;
        if (a.sensor_id > b.sensor_id) return 1;
        return 0;
      });

      // トレンドグラフ描画対象のセンサを取得
      const targetSensors = [];
      for (const trendGroupSensor of this.infoPresetTrendgroup.sensors) {
        const targetSensor = sensors.filter((sensor) => sensor.name_locale2 === trendGroupSensor.label);
        if (targetSensor.length > 0) {
          targetSensors.push(targetSensor[0]);
        }
      }
      this.trendGroupSensors = targetSensors;

      this.$store.commit('loading/end_loading');
    },
    methods: {
      // チャートを描画する
      async updateChart() {
        if (!this.isDateSettingValid() || !(await this.isLongTimePeriod())) {
          return;
        }

        // 描画ごとに縦軸の範囲をリセットする
        await this.setLocale();

        this.$store.commit('loading/start_loading');

        // UTCで開始・終了日時を設定
        const utcOffset = this.$dayjs().utcOffset();
        const { beginDate, endDate, utcBeginDate, utcEndDate } = this.getDatePeriodFromSetting();
        console.log('開始日:', utcBeginDate, '終了日:', utcEndDate);

        // タイムゾーンに合わせた描画範囲を設定
        for (const options of [
          this.pressureOptions,
          this.temperatureOptions,
          this.electricCurrentOptions,
          this.loadOptions,
        ]) {
          options.xaxis.min = beginDate.valueOf();
          options.xaxis.max = endDate.valueOf();
        }

        // イベント・アラームデータを取得
        const eventHistoryData = await this.getDataInChunks(this.getEventHistoryData, utcBeginDate, utcEndDate);

        // event_levelの変換  E：赤、C：橙、M：黄
        const convertBorderColor = (event_level) => {
          if (event_level === '3') {
            return '#ff0000'; // E
          } else if (event_level === '2') {
            return '#ffa500'; // C
          } else if (event_level === '1') {
            return '#ffff00'; // M
          }
        };

        // アノテーションを設定
        if (eventHistoryData.length > 0) {
          for (const options of [
            this.pressureOptions,
            this.temperatureOptions,
            this.electricCurrentOptions,
            this.loadOptions,
          ]) {
            options.annotations.xaxis = eventHistoryData.map((item) => {
              const borderColor = convertBorderColor(item.event_level);
              return {
                x: this.$dayjs.utc(item.event_time).utcOffset(utcOffset).valueOf(),
                borderColor: borderColor,
                label: {
                  borderColor: borderColor,
                  text: item[`name_locale${this.localeId}`],
                },
              };
            });
          }
        }

        // チャートオプションを更新
        this.$refs.pressureChart.updateOptions(this.pressureOptions);
        this.$refs.temperatureChart.updateOptions(this.temperatureOptions);
        this.$refs.electricCurrentChart.updateOptions(this.electricCurrentOptions);
        this.$refs.loadChart.updateOptions(this.loadOptions);

        // センサーデータを取得
        const sensorDatas = await this.getDataInChunks(this.getSensorData, utcBeginDate, utcEndDate, [
          this.trendGroupSensors,
        ]);
        if (sensorDatas.length === 0) {
          this.$store.commit('loading/end_loading');
          return;
        }
        const sensorData = this.mergeSensorData(sensorDatas);

        // timeListにそれぞれのセンサデータが入っているので
        // ApexCharts.jsのフォーマットに合うようにx,yの形に変換する
        const pressureSeries = [];
        const temperatureSeries = [];
        const electricCurrentSeries = [];
        const loadSeries = [];

        const seriesLabels = [];
        const timeLists = sensorData.timeList;
        for (const timeList of timeLists) {
          const sensor = this.trendGroupSensors.filter((sensor) => sensor.sensor_id === timeList.sensorId)[0];
          const dataList = timeList.dataList.map((item) => {
            return {
              x: this.$dayjs.utc(item.measureTime).utcOffset(utcOffset).toISOString(true),
              // y: sensor.unit_locale2 === 'kPa' ? item.data / 1000 : item.data //kPa → MPa変換 浮動小数点の計算誤差がでる
              y: sensor.unit_locale2 === 'kPa' ? Math.round(item.data * 100) / 100000 : item.data, //kPa → MPa変換
            };
          });

          // データ間隔が一定時間を超えている場合は
          // グラフを途切れさせるため、間にnullのデータを挿入する
          const data = [];
          let prevData = null;
          for (let i = 0, len = dataList.length; i < len; i++) {
            const currentData = dataList[i];
            if (prevData !== null) {
              const prevMeasureTime = this.$dayjs(prevData.x);
              const currentMeasureTime = this.$dayjs(currentData.x);

              if (currentMeasureTime.diff(prevMeasureTime, 'minutes') > 5) {
                data.push({
                  x: prevMeasureTime.add(1, 'minutes').toISOString(true),
                  y: null,
                });
              }
            }

            data.push(currentData);
            prevData = currentData;
          }

          // 点数が多いと描画エラーになるのでダウンサンプリング
          const sampledData = this.downSample(data);

          const series = {
            sensorId: sensor.sensor_id, // ソート用
            name: sensor[`name_locale${this.localeId}`],
            data: sampledData,
          };

          // 単位を見て適切なグラフにデータをセット
          if (sensor.unit_locale2 === 'MPa' || sensor.unit_locale2 === 'kPa') {
            pressureSeries.push(series);
          } else if (sensor.unit_locale2 === '℃') {
            temperatureSeries.push(series);
          } else if (sensor.unit_locale2 === 'A') {
            electricCurrentSeries.push(series);
          } else {
            loadSeries.push(series);
          }

          seriesLabels[sensor.name_locale2] = series.name;
        }

        // センサーID（アドレスマップ）順でソート
        const sortFunc = function (o1, o2) {
          if (o1.sensorId < o2.sensorId) {
            return -1;
          } else if (o1.sensorId > o2.sensorId) {
            return 1;
          }
          return 0;
        };

        // ソート後に不要な項目を削除
        const removeSensorId = function (el) {
          delete el.sensorId;
        };

        // ソート処理
        pressureSeries.sort(sortFunc).forEach(removeSensorId);
        temperatureSeries.sort(sortFunc).forEach(removeSensorId);
        electricCurrentSeries.sort(sortFunc).forEach(removeSensorId);
        loadSeries.sort(sortFunc).forEach(removeSensorId);

        // チャートを描画
        await Promise.all([
          this.$refs.pressureChart.updateSeries(pressureSeries),
          this.$refs.temperatureChart.updateSeries(temperatureSeries),
          this.$refs.electricCurrentChart.updateSeries(electricCurrentSeries),
          this.$refs.loadChart.updateSeries(loadSeries),
        ]);

        // 初期状態でグラフを表示させない項目
        for (const trendGroupSensor of this.infoPresetTrendgroup.sensors) {
          if (trendGroupSensor.show === false) {
            const seriesLabel = seriesLabels[trendGroupSensor.label];
            if (trendGroupSensor.unit === 'MPa' || trendGroupSensor.unit === 'kPa') {
              this.$refs.pressureChart.hideSeries(seriesLabel);
            } else if (trendGroupSensor.unit === '℃') {
              this.$refs.temperatureChart.hideSeries(seriesLabel);
            } else if (trendGroupSensor.unit === 'A') {
              this.$refs.electricCurrentChart.hideSeries(seriesLabel);
            } else {
              this.$refs.loadChart.hideSeries(seriesLabel);
            }
          }
        }

        this.$store.commit('loading/end_loading');
      },
      async downloadCSV() {
        if (!this.isDateSettingValid() || !(await this.isLongTimePeriod())) {
          return;
        }

        this.$store.commit('loading/start_loading');

        // ヘッダ生成
        let items = [];
        let header = [this.$t('dateTime')];
        const keys = this.sensors.map((item) => item[`name_locale${this.localeId}`]);
        header = header.concat(keys);
        items.push(header);

        // UTCで開始・終了日時を設定
        const utcOffset = this.$dayjs().utcOffset();
        const { utcBeginDate, utcEndDate } = this.getDatePeriodFromSetting();
        console.log('開始日:', utcBeginDate, '終了日:', utcEndDate);

        // センサーデータを取得
        const sensorDatas = await this.getDataInChunks(this.getSensorData, utcBeginDate, utcEndDate, [this.sensors]);
        if (sensorDatas.length === 0) {
          this.$store.commit('loading/end_loading');
          return;
        }
        const sensorData = this.mergeSensorData(sensorDatas);

        let datetimeList = [];
        const timeLists = sensorData.timeList;
        const dataMap = new Map();
        for (const timeList of timeLists) {
          // Arrayだと処理が遅いので、Mapを生成
          dataMap.set(timeList.sensorId, new Map(timeList.dataList.map((item) => [item.measureTime, item.data])));

          // 日時列を重複ないように生成
          for (const dataList of timeList.dataList) {
            datetimeList.push(dataList.measureTime);
          }
          datetimeList = Array.from(new Set(datetimeList));
        }
        datetimeList.sort();

        // 行を生成
        for (const datetime of datetimeList) {
          let lineData = [];
          lineData.push(this.$dayjs.utc(datetime).utcOffset(utcOffset).format('YYYY-MM-DD HH:mm:ss'));
          for (const sensor of this.sensors) {
            const dataList = dataMap.get(sensor.sensor_id);
            if (dataList.size === 0) {
              lineData.push('');
            } else {
              if (dataList.has(datetime)) {
                let data = dataList.get(datetime);
                if (sensor.name_locale2.includes('(Hex)')) {
                  data = Number(data).toString(16);
                  data = ('0000' + data).slice(-4);
                }
                lineData.push(data);
              } else {
                lineData.push('');
              }
            }
          }

          items.push(lineData);
        }

        const fileName = `${this.$dayjs().format('YYYYMMDD')}.csv`;
        this.downloadCsv(fileName, items);

        this.$store.commit('loading/end_loading');
      },
      // ぱんくずリストクリック
      selectedGroupChange(group) {
        this.$router.push({
          name: group.children.length > 0 ? 'HomeAdmin' : 'HomeConsumer',
          params: { device_group_id: group.device_group_id },
        });
      },
      selectedDeviceChange(device) {
        this.$router.push({
          name: 'CompressorInfo',
          params: { model_id: device.model_id, serial_no: device.serial_no },
        });
      },
      async setLocale() {
        switch (this.$i18n.locale) {
          case 'en':
            this.localeId = 1;
            break;
          case 'ja':
            this.localeId = 2;
            break;
          case 'zh':
            this.localeId = 3;
            break;
        }

        // デフォルトオプションを取得
        this.pressureOptions = this.$refs.pressureChart.getOptions();
        this.temperatureOptions = this.$refs.temperatureChart.getOptions();
        this.electricCurrentOptions = this.$refs.electricCurrentChart.getOptions();
        this.loadOptions = this.$refs.loadChart.getOptions();

        // 縦軸の範囲をリセット
        this.pressureOptions.yaxis[0].min = undefined;
        this.pressureOptions.yaxis[0].max = undefined;
        this.pressureOptions.yaxis[0].tickAmount = undefined;
        this.temperatureOptions.yaxis[0].min = undefined;
        this.temperatureOptions.yaxis[0].max = undefined;
        this.temperatureOptions.yaxis[0].tickAmount = undefined;
        this.electricCurrentOptions.yaxis[0].min = undefined;
        this.electricCurrentOptions.yaxis[0].max = undefined;
        this.electricCurrentOptions.yaxis[0].tickAmount = undefined;
        this.loadOptions.yaxis[0].min = undefined;
        this.loadOptions.yaxis[0].max = undefined;
        this.loadOptions.yaxis[0].tickAmount = undefined;

        // y軸設定（タイトル）
        this.pressureOptions.yaxis[0].title.text = `${this.$t('pressure')} (${this.localeId === 1 ? 'bar' : 'MPa'})`;
        this.temperatureOptions.yaxis[0].title.text = `${this.$t('temperature')} (℃)`;
        this.electricCurrentOptions.yaxis[0].title.text = `${this.$t('current')} (A)`;
        this.loadOptions.yaxis[0].title.text = `${this.$t('loadCondition')} (%)`;

        // y軸ラベル最小幅（グラフの始まりを合わせるため）
        for (const options of [
          this.pressureOptions,
          this.temperatureOptions,
          this.electricCurrentOptions,
          this.loadOptions,
        ]) {
          options.yaxis[0].labels.minWidth = 100;
        }
        // 単位を見て適切なグラフに最大・最小値、描画目盛り数をセット
        for (const trendGroupSensor of this.infoPresetTrendgroup.sensors) {
          const min = trendGroupSensor.min === '' ? undefined : Number(trendGroupSensor.min);
          const max = trendGroupSensor.max === '' ? undefined : Number(trendGroupSensor.max);

          if (min === undefined && max === undefined) {
            //未定義は上書きしない
            continue;
          }
          this.pressureOptions.yaxis[0].labels.formatter = (val) => {
            if (val == null) {
              return null;
            }
            // -0.00000001のような場合 0にみえてマイナス符号がつくので回避
            if (val.toFixed(4) == 0.0) {
              return '0.0000';
            }
            // formatterを使うとdecimalsInFloatが無効になるので同等機能を追加
            return val.toFixed(4);
          };

          if (trendGroupSensor.unit === 'MPa') {
            this.pressureOptions.yaxis[0].min = this.localeId === 1 ? 10 * min : min; // 英の場合は10倍にする
            this.pressureOptions.yaxis[0].max = this.localeId === 1 ? 10 * max : max; // 英の場合は10倍にする
            this.pressureOptions.yaxis[0].tickAmount = 8;
            //this.pressureOptions.yaxis[0].decimalsInFloat = 4 // 表示は小数点以下4桁まで
          } else if (trendGroupSensor.unit === 'kPa') {
            this.pressureOptions.yaxis[0].min = (this.localeId === 1 ? 10 * min : min) / 1000; // kPa → MPa変換
            this.pressureOptions.yaxis[0].max = (this.localeId === 1 ? 10 * max : max) / 1000; // kPa → MPa変換
            this.pressureOptions.yaxis[0].tickAmount = 8;
            //this.pressureOptions.yaxis[0].decimalsInFloat = 4 // 表示は小数点以下4桁まで
          } else if (trendGroupSensor.unit === '℃') {
            this.temperatureOptions.yaxis[0].min = min;
            this.temperatureOptions.yaxis[0].max = max;
            // 50 刻み 条件が複雑になれば info_preset_trendgroups.jsonに持たせてることも検討
            let tick = (max - min) / 50;
            this.temperatureOptions.yaxis[0].tickAmount = tick;
          } else if (trendGroupSensor.unit === 'A') {
            this.electricCurrentOptions.yaxis[0].min = min;
            this.electricCurrentOptions.yaxis[0].max = max;
            this.electricCurrentOptions.yaxis[0].tickAmount = 5;
          } else {
            this.loadOptions.yaxis[0].min = min;
            this.loadOptions.yaxis[0].max = max;
            this.loadOptions.yaxis[0].tickAmount = 7;
          }
        }

        // x軸設定(UTCかどうか)
        for (const options of [
          this.pressureOptions,
          this.temperatureOptions,
          this.electricCurrentOptions,
          this.loadOptions,
        ]) {
          options.xaxis.labels.datetimeUTC = false;
        }

        // ツールバー表示
        // this.pressureOptions.chart.toolbar.show = true
        // this.temperatureOptions.chart.toolbar.show = true
        // this.electricCurrentOptions.chart.toolbar.show = true
        // this.loadOptions.chart.toolbar.show = true

        const tooltipOptions = {
          enabled: true,
          fixed: {
            enabled: true,
            position: 'topLeft',
            offsetX: 0,
            offsetY: 0,
          },
        };
        this.pressureOptions.tooltip = tooltipOptions;
        this.temperatureOptions.tooltip = tooltipOptions;
        this.electricCurrentOptions.tooltip = tooltipOptions;
        this.loadOptions.tooltip = tooltipOptions;

        // チャートオプションを更新
        await this.$refs.pressureChart.updateOptions(this.pressureOptions);
        await this.$refs.temperatureChart.updateOptions(this.temperatureOptions);
        await this.$refs.electricCurrentChart.updateOptions(this.electricCurrentOptions);
        await this.$refs.loadChart.updateOptions(this.loadOptions);
      },
      async getDataInChunks(func, utcBeginDate, utcEndDate, args = []) {
        // 長期間を一括取得できないので1カ月分ごとに分割して取得する
        console.log('getDataInChunks Start');

        const results = [];
        let cursor = utcBeginDate;
        while (cursor.isBefore(utcEndDate)) {
          const chunkEnd = this.$dayjs.min(cursor.add(31, 'day'), utcEndDate); // 31日分
          console.log(`Begin: ${cursor.format('YYYY-MM-DD HH:mm:ss.0000000')}`);
          console.log(`End  : ${chunkEnd.format('YYYY-MM-DD HH:mm:ss.9999999')}`);
          const data = await func(
            cursor.format('YYYY-MM-DD HH:mm:ss.0000000'),
            chunkEnd.format('YYYY-MM-DD HH:mm:ss.9999999'),
            ...args
          );
          if (data) {
            results.push(data);
          }
          cursor = chunkEnd;
        }
        console.log('getDataInChunks End');

        return results.flat();
      },
      downSample(data, maxPoints = 50000) {
        if (data.length <= maxPoints) return data;
        const step = Math.ceil(data.length / maxPoints);
        return data.filter((_, i) => i % step === 0);
      },
      async getEventHistoryData(utcBeginDate, utcEndDate) {
        return await this.apiRequest('/v1/alarm-event-mgt/eventHistory', 'GET', {
          get_class: '4',
          sort: '-event_time',
          event_level: '0,1,2,3',
          incident_class: 1,
          max_number: 2000,
          event_time_from: utcBeginDate,
          event_time_to: utcEndDate,
          'device_list[0].model_id': this.modelId,
          'device_list[0].serial_no': this.serialNo,
        });
      },
      async getSensorData(utcBeginDate, utcEndDate, sensors) {
        return await this.apiRequest('/v1/sensor-data-file-mgt/getSensorData', 'POST', {
          get_class: 1,
          locale_id: this.localeId,
          max_number: 30000,
          measure_time_from: utcBeginDate,
          measure_time_to: utcEndDate,
          round_kbn: 1,
          sensor_list: sensors.map((sensor) => {
            return {
              model_id: this.modelId,
              sensor_id: sensor.sensor_id,
              serial_no: this.serialNo,
            };
          }),
          iso8601_datetime_format: true,
        });
      },
      mergeSensorData(sensorDatas) {
        const mergedSensorData = {
          modelId: this.modelId,
          serialNo: this.serialNo,
          timeList: [],
        };

        for (const sensorData of sensorDatas) {
          for (const timeList of sensorData.timeList) {
            const mergedTimeList = mergedSensorData.timeList.find((item) => item.sensorId === timeList.sensorId);

            if (!mergedTimeList) {
              mergedSensorData.timeList.push({
                ...timeList,
                dataList: [...timeList.dataList],
              });
            } else {
              // dataList をマージ
              mergedTimeList.dataList.push(...timeList.dataList);
            }
          }
        }

        console.log(mergedSensorData);
        return mergedSensorData;
      },
      getDatePeriodFromSetting() {
        let beginDateBase;
        let endDateBase;
        if (this.selectedItem === 'anyPeriod') {
          // 任意期間設定の場合
          beginDateBase = this.$dayjs(this.startSelectedDate);
          endDateBase = this.$dayjs(this.endSelectedDate);
        } else {
          switch (this.selectedItem) {
            case 1:
              beginDateBase = this.$dayjs(this.startSelectedDate);
              break;
            case 7:
              beginDateBase = this.$dayjs(this.startSelectedDate).add(-6, 'days');
              break;
            case 31:
              beginDateBase = this.$dayjs(this.startSelectedDate).add(-1, 'month').add(1, 'days');
              break;
            case 180:
              beginDateBase = this.$dayjs(this.startSelectedDate).add(-6, 'month').add(1, 'days');
              break;
            case 365:
              beginDateBase = this.$dayjs(this.startSelectedDate).add(-1, 'year').add(1, 'days');
              break;
          }
          endDateBase = this.$dayjs(this.startSelectedDate);
        }

        const beginDate = this.$dayjs(beginDateBase.format('YYYY-MM-DD 00:00:00.0000000'));
        const endDate = this.$dayjs(endDateBase.format('YYYY-MM-DD 23:59:59.9999999'));

        const utcBeginDate = this.$dayjs.utc(beginDate);
        const utcEndDate = this.$dayjs.utc(endDate);

        return {
          beginDate,
          endDate,
          utcBeginDate,
          utcEndDate,
        };
      },
      isDateSettingValid() {
        let errMsg = '';
        if (this.selectedItem === 'anyPeriod') {
          // 任意期間設定の場合

          if (this.$refs.startCal.hasError || this.$refs.endCal.hasError) {
            errMsg = 'invalidDateEntered';
          } else {
            const beginDate = this.$dayjs(this.startSelectedDate);
            const endDate = this.$dayjs(this.endSelectedDate);

            // 開始・終了が逆の場合
            if (endDate.isBefore(beginDate)) {
              errMsg = 'toMustBeALaterDateThanFrom';
            }

            // 指定期間が366日を超えている場合
            if (endDate.diff(beginDate, 'day') > 366) {
              errMsg = 'theOptionalPeriodMustBeWithin366Days';
            }
          }
        } else {
          if (this.$refs.startCal.hasError) {
            errMsg = 'invalidDateEntered';
          }
        }

        if (errMsg) {
          this.$store.commit('snackbar/show_snackbar', {
            text: this.$t(errMsg),
            color: 'error',
            timeout: 5000,
            multiline: false,
          });
          return false;
        } else {
          return true;
        }
      },
      async isLongTimePeriod() {
        let isOpenDialog = false;
        if (this.selectedItem === 'anyPeriod') {
          const beginDate = this.$dayjs(this.startSelectedDate);
          const endDate = this.$dayjs(this.endSelectedDate);

          // 指定期間が半年を超えている場合
          if (endDate.diff(beginDate, 'day') >= 180) {
            isOpenDialog = true;
          }
        } else if (this.selectedItem === 180 || this.selectedItem === 365) {
          isOpenDialog = true;
        }

        if (isOpenDialog) {
          this.dialog = true;
          const result = await new Promise((resolve) => {
            this.resolveDialog = resolve;
          });
          return result;
        } else {
          return true;
        }
      },
      dialogOK() {
        this.dialog = false;
        if (this.resolveDialog) {
          this.resolveDialog(true);
        }
      },
      dialogCancel() {
        this.dialog = false;
        if (this.resolveDialog) {
          this.resolveDialog(false);
        }
      },
    },
  };
</script>
